// Formati canonici §9.3. Nessun componente formatta numeri da sé.
const IT = (n: number, d = 1) => n.toFixed(d).replace('.', ',');

export function tokens(n: number): string {
  if (n >= 1_000_000) return IT(n / 1_000_000, 2) + 'M';
  if (n >= 1000) return IT(n / 1000, 1) + 'k';
  return String(n);
}

export function tokensExact(n: number): string {
  // it-IT separa le migliaia con uno spazio unificatore (U+00A0); la spec §9.3 vuole
  // lo spazio fine (U+2009). Scritti come escape perché a occhio sono indistinguibili.
  return n.toLocaleString('it-IT').replace(/\u00A0/g, '\u2009') + ' token';
}

export function eur(v: number): string {
  return IT(v, 2) + ' €';
}

export function ratio(tok: number, cost: number): string {
  if (cost <= 0) return 'gratis';
  return tokens(Math.round(tok / cost)) + ' token / €';
}

export function pct(a: number, b: number): string {
  if (b <= 0) return '0%';
  return Math.round((a / b) * 100) + '%';
}

export function pctNum(a: number, b: number): number {
  if (b <= 0) return 0;
  return Math.min(100, (a / b) * 100);
}

export function duration(ms: number): string {
  if (ms < 1000) return Math.round(ms) + ' ms';
  if (ms < 60_000) return IT(ms / 1000, 1) + ' s';
  const min = Math.floor(ms / 60_000);
  const sec = Math.round((ms % 60_000) / 1000);
  if (min < 60) return sec ? min + ' min ' + sec + ' s' : min + ' min';
  const h = Math.floor(min / 60);
  return h + ' h ' + (min % 60) + ' min';
}

export function shortId(id: string): string {
  if (id.length <= 12) return id;
  return id.slice(0, 8) + '…' + id.slice(-2);
}

export function cron(expr: string): string {
  const known: Record<string, string> = {
    '0 3 * * *': 'ogni notte alle 03:00',
    '0 3 * * 1': 'ogni lunedì alle 03:00',
    '*/15 * * * *': 'ogni 15 minuti',
  };
  return known[expr] ?? expr;
}

export function truncateMiddle(s: string, max = 34): string {
  if (s.length <= max) return s;
  const half = Math.floor((max - 1) / 2);
  return s.slice(0, half) + '…' + s.slice(-half);
}
